<div class="dialog-titlebar">
  <span class="dialog-title"> Download Document</span>
  <span class="close-icon pointer-cursor" (click)="closeModal()">&#x2715;</span>
</div>
<div class="dialog-content">
  <span>Your file '<b>{{fileName}}</b>' is downloaded. Meanwhile, you can download the document directly through the link</span>
  <div class="copyable-section">
    <label class="link-content"> {{documentLink}} </label>
    <div class="tooltip-head">
      <i class="site-icon-copy primary-color pointer-cursor" (click)="copyText()" (mouseout)="changeTooltip()"></i>
      <div class="tooltip-text"> {{tooltipText}}</div>
    </div>
  </div>
</div>
